import { faHeart } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import AdminSearchForm from "../../../forms/AdminSearchForm";
import AdminNav from "../../../nav/AdminNav";
import { useTable, usePagination } from 'react-table'
import Select from 'react-select'
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { faExclamationCircle, faHeart as solidHeart, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
// import { useDispatch } from "react-redux";
// import { openModal } from "../../../../app/common/modals/modalReducer";
import { useHistory } from "react-router";
import { openModal } from "../../../../app/common/modals/modalReducer"
import ReactTooltip from "react-tooltip";
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from "react-toastify";
import { getCartTotal } from "../../../nav/NavBar/cartActions";
import {
    canRetryPaym8,
    getPaym8RetryErrorMessage,
    getPaym8RetryMessageType,
    retryPaym8Order,
} from "../payments/paym8Retry";

function normalizeRecord(value) {
    return Array.isArray(value) ? value[0] : value;
}

function OrderTable({ items, columns }) {
    const data = React.useMemo(() => items, [items]);
    const tableInstance = useTable({ columns, data, manualPagination: true }, usePagination);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
    } = tableInstance;

    return (
        <table {...getTableProps()} className="mb-10 w-full" style={{ borderCollapse: "separate", borderSpacing: "0 1em" }}>
            <thead>
                {
                    headerGroups.map(headerGroup => (

                        <tr {...headerGroup.getHeaderGroupProps()} className="bg-gray-100 bg-gray-100 flex flex-col flex-no wrap md:table-row w-full">
                            {
                                headerGroup.headers.map(column => (

                                    <th {...column.getHeaderProps()} className="lg:px-5 lg:py-5 font-light">
                                        {column.render('Header')}
                                    </th>
                                ))}
                        </tr>
                    ))}
            </thead>
            <tbody {...getTableBodyProps()}>
                {
                    page.map(row => {

                        prepareRow(row)
                        return (

                            <tr {...row.getRowProps()} className="bg-white rounded mt-5 bg-white rounded mt-5 flex flex-col flex-no wrap md:table-row" >
                                {
                                    row.cells.map(cell => {

                                        return (
                                            <td {...cell.getCellProps()} className="mx-auto text-center relative lg:border-r md:border-r border-slate-300">

                                                {(cell.render('Cell').props.cell.column.id === "col2" || cell.render('Cell').props.cell.column.id === "col4") ? (
                                                    <div className="text-center px-5 py-5 text-gray-500">{cell.render('Cell')}</div>
                                                ) : (
                                                    cell.render('Cell')
                                                )}
                                            </td>
                                        )
                                    })}
                            </tr>
                        )
                    })}
            </tbody>
        </table>
    );
}

export default function SpecificOrder(props) {

    let history = useHistory();
    let dispatch = useDispatch();

    let orderId = props.match.params.orderId;
    // const dispatch = useDispatch();

    const { currentUser } = useSelector((state) => state.auth);
    const [cartTotal, setCartTotal] = useState([])
    const [orderBundles, setOrderBundles] = useState([])
    const [isRepeating, setIsRepeating] = useState(false);
    const [retryingPaymentOrderId, setRetryingPaymentOrderId] = useState("");
    const [paymentRetryMessages, setPaymentRetryMessages] = useState({});

    const allowedSups = currentUser.supplier_stock != null ? currentUser.supplier_stock.split(",").map(function (item) { return item.trim(); }) : currentUser.supplier_stock;

    useEffect(() => {
        setCartTotal(parseFloat(window.sessionStorage.getItem("itemsInBasket")));
        getOrder();
    }, [])



    async function getOrder() {
        const customerCode =
            currentUser.isCustomer === 1 && currentUser.customer_code !== null
                ? currentUser.customer_code
                : currentUser.customer_code === null || currentUser.customer_code.split(",").length > 1
                    ? "None"
                    : currentUser.customer_code;
        const placedOrderNosRaw = window.sessionStorage.getItem("placedOrderNos");
        const placedOrderNosUser = window.sessionStorage.getItem("placedOrderNosUser");
        let placedOrderNos = [];
        if (placedOrderNosRaw && placedOrderNosUser === String(currentUser.id)) {
            try {
                const parsed = JSON.parse(placedOrderNosRaw);
                if (Array.isArray(parsed)) {
                    placedOrderNos = parsed;
                } else if (parsed) {
                    placedOrderNos = [parsed];
                }
            } catch (error) {
                placedOrderNos = [];
            }
        }

        const normalizedPlaced = placedOrderNos
            .map((value) => `${value}`.trim())
            .filter((value) => value !== "");

        let orderIds = [orderId];
        if (normalizedPlaced.length > 1 && normalizedPlaced.includes(String(orderId))) {
            orderIds = normalizedPlaced;
        }

        const [favouritesResults, cartItems] = await Promise.all([
            axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}favourites`,
                headers: { Authorization: `Bearer ${currentUser.token}` },
                data: {
                    userId: currentUser.id
                },
            }),
            axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}get-items-in-cart`,
                headers: { Authorization: `Bearer ${currentUser.token}` },
                data: {
                    id: currentUser.id,
                    priceCode: currentUser.customer_code,
                    branch: currentUser.branch,
                },
            }),
        ]);

        let cartItemData = cartItems.data[1] || [];

        let favData = favouritesResults.data[0] || [];
        let prodDataSubCode = favouritesResults.data[1] || [];
        let favIds = [];

        Object.keys(favData).forEach(function (key) {
            favIds.push(favData[key].favourite_product_id)
        })

        let allCodes = [];

        prodDataSubCode.forEach(function (subCode) {
            allCodes.push(subCode.stock_code)
        });

        const orderResponses = await Promise.all(
            orderIds.map((id) =>
                axios({
                    method: "post",
                    url: `${process.env.REACT_APP_API_URL}this-orders`,
                    headers: { Authorization: `Bearer ${currentUser.token}` },
                    data: {
                        userId: currentUser.id,
                        orderId: id,
                        customer_code: customerCode,
                    },
                })
            )
        );

        const bundles = orderResponses.map((orderResponse, index) => {
            let orderDetails = orderResponse.data || [];
            let ordeItems = orderDetails[0] || [];
            const paymentDetails = normalizeRecord(orderDetails[1]) || {};
            const orderTrack = normalizeRecord(orderDetails[2]) || {};
            let allproducts = [];

            Object.keys(ordeItems).forEach(function (key) {
                let curfav = false;
                const stockCode = (ordeItems[key].MStockCode || "").trim();

                if (stockCode !== "" && favIds.includes(stockCode)) {
                    curfav = true;
                }

                let display = "";

                if (prodDataSubCode.length > 0 && allCodes.includes(ordeItems[key].MStockCode)) {
                    prodDataSubCode.forEach(function (subCode) {
                        if (subCode.stock_code == ordeItems[key].MStockCode) {
                            display = subCode.custom_code
                        }
                    });
                }

                let inCart = "no";

                Object.keys(cartItemData).forEach(function (index) {
                    if (
                        cartItemData[index].stock_code === ordeItems[key].MStockCode

                    ) {
                        inCart = "yes";
                    }
                });

                // MPrice
                // col5: "R " + parseFloat(ordeItems[key].MUnitCost).toFixed(2), 

                allproducts.push({
                    col0: ordeItems[key].MStockCode,
                    col1: '',
                    col2: ordeItems[key].MStockCode,
                    col3: ordeItems[key].MStockDes,
                    col4: ordeItems[key].InvWarehouse,
                    col5: "R " + parseFloat(ordeItems[key].MPrice).toFixed(2),
                    col6: ordeItems[key].MOrderQty,
                    col7: curfav,
                    col9: ordeItems[key].altStock,
                    col10: ordeItems[key].AlternateUom,
                    col11: inCart,
                    col12: display,
                    col13: ordeItems[key].img,
                    col23: ordeItems[key].UserField1,
                    col24: ordeItems[key].AlternateKey2,
                    col25: ordeItems[key].InvwarehouseQty,
                    col26: ordeItems[key].MBackOrderQty,
                    col27: ordeItems[key].Supplier,
                })
            })

            return {
                orderId: orderIds[index],
                orderTrack: orderTrack,
                paymentDetails: paymentDetails,
                latestPayment: orderTrack.latest_payment || paymentDetails.latest_payment || orderDetails.latest_payment,
                paymentRetry: orderTrack.payment_retry || paymentDetails.payment_retry || orderDetails.payment_retry,
                comments: orderDetails[3],
                items: allproducts,
            };
        });

        setOrderBundles(bundles);
    }

    async function addItemToCart(itemId, qty) {

        itemId = itemId.trim();

        let cartItem = await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}add-items-to-cart`,
            headers: { Authorization: `Bearer ${currentUser.token}` },
            data: {
                StockCode: itemId,
                id: currentUser.id,
                qty: qty,
                auto: 0,
                customer_code: currentUser.customer_code,
            },
        });

        if (cartItem.data == 1) {
            let CurrentCartAmount = window.sessionStorage.getItem("itemsInBasket")
            let NewAmount = parseFloat(CurrentCartAmount) + 1
            window.sessionStorage.setItem("itemsInBasket", NewAmount);
        }

        dispatch(getCartTotal(currentUser));

        toast.success("Item Added to Cart", { position: "bottom-right", autoClose: 5000, closeOnClick: true, });

        await getOrder();

        //   itemId = itemId.trim();
        //   let prevItemClicked = JSON.parse(
        //       window.sessionStorage.getItem("itemsClicked")
        //   );
        //   if (prevItemClicked !== null) {
        //       window.sessionStorage.setItem(
        //           "itemsClicked",
        //           JSON.stringify([...prevItemClicked, itemId])
        //       );
        //   } else {
        //       window.sessionStorage.setItem(
        //           "itemsClicked",
        //           JSON.stringify(itemId)
        //       );
        //   }

        //   let prevItemIds = JSON.parse(
        //       window.sessionStorage.getItem("itemsIdsInBasket")
        //   );

        //   if (!prevItemIds.includes(itemId)) {
        //       window.sessionStorage.setItem(
        //           "itemsIdsInBasket",
        //           JSON.stringify([...prevItemIds, itemId])
        //       );

        //       let CurrentCartAmount =
        //           window.sessionStorage.getItem("itemsInBasket");
        //       let NewAmount = parseFloat(CurrentCartAmount) + 1;
        //       window.sessionStorage.setItem("itemsInBasket", NewAmount);
        //       setCartTotal(NewAmount);

        //   } else {
        //       let totalItemsClicked = JSON.parse(
        //           window.sessionStorage.getItem("itemsClicked")
        //       );
        //       let thisItem = 0;

        //       await Object.keys(totalItemsClicked).forEach(function (key) {
        //           if (totalItemsClicked[key] === itemId) {
        //               thisItem += 1;
        //           }
        //       });

        //       let prevItemTotals = JSON.parse(
        //           window.sessionStorage.getItem("totalItemsInBasket")
        //       );
        //       if (prevItemTotals !== null) {
        //           window.sessionStorage.setItem(
        //               "totalItemsInBasket",
        //               JSON.stringify([...prevItemTotals, [thisItem, itemId]])
        //           );
        //       } else {
        //           window.sessionStorage.setItem(
        //               "totalItemsInBasket",
        //               JSON.stringify([[thisItem, itemId]])
        //           );
        //       }
        //   }
    }

    const isPromoBlockedItem = (item) => {
        const fields = [
            item?.col0,
            item?.col2,
            item?.col12,
            item?.col23,
            item?.col24,
        ];
        return fields.some((value) => {
            if (!value) return false;
            const upper = `${value}`.toUpperCase();
            return upper.includes("MPROMO") || upper.includes("FPROMO");
        });
    };

    async function addFavourite(rowId) {
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}add-new-favourite`,
            headers: { Authorization: `Bearer ${currentUser.token}` },
            data: {
                rowId: rowId,
                userId: currentUser.id
            },
        });

        getOrder();
    }

    async function removeFavourite(rowId) {
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}remove-favourite`,
            headers: { Authorization: `Bearer ${currentUser.token}` },
            data: {
                rowId: rowId,
                userId: currentUser.id
            },
        });

        getOrder();
    }

    async function setTotals(totalAmount, itemId) {
        itemId = itemId.trim();

        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}update-qty-in-cart`,
            headers: { Authorization: `Bearer ${currentUser.token}` },
            data: {
                StockCode: itemId,
                id: currentUser.id,
                qty: totalAmount,
                customer_code: currentUser.customer_code,
            },
        });

        await getOrder();
        //   let prevItemTotals = JSON.parse(window.sessionStorage.getItem("totalItemsInBasket"));
        //   if(prevItemTotals !== null){
        //     window.sessionStorage.setItem("totalItemsInBasket", JSON.stringify([...prevItemTotals, [totalAmount, itmeId]]));
        //   }else{
        //     window.sessionStorage.setItem("totalItemsInBasket", JSON.stringify([[totalAmount, itmeId]]));
        //   }    
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'Image',
                accessor: 'col1',
                Cell: tableProps => (
                    <img
                        src={tableProps.row.original.col13 !== "" ? process.env.REACT_APP_URL + 'media/' + tableProps.row.original.col13 : process.env.REACT_APP_URL + "/images/placeholder-image.png"}
                        width={150}
                        alt='Product'
                        className="mx-auto px-5 py-5"
                    />
                )
            },
            {
                Header: 'Code',
                accessor: 'col2',
                Cell: (rowInfo) => {
                    return (
                        <>
                            {rowInfo.row.original.col12 !== "" ? rowInfo.row.original.col12 : rowInfo.row.original.col2}
                        </>
                    )
                }
            },
            {
                Header: 'Description',
                accessor: 'col3',
            },
            // {
            //     Header: 'Pet Brands',
            //     accessor: 'col23',
            //     Cell: (rowInfo) => {
            //         return (
            //             <>
            //                 {rowInfo.row.original.col23 !== ""
            //                     ? rowInfo.row.original.col23 + " - " + rowInfo.row.original.col24
            //                     : rowInfo.row.original.col23 + " - " + rowInfo.row.original.col24}
            //             </>
            //         );
            //     },
            // },
            {
                Header: 'Stock Status',
                accessor: 'col4',
                Cell: (rowInfo) => {
                    return (
                        <>
                            {rowInfo.row.original.col4 === "Out of Stock" ?
                                <p className="text-red-500">{rowInfo.row.original.col4} {currentUser.see_stock === 1 && currentUser.supplier_stock !== null && allowedSups.includes(rowInfo.row.original.col27) ? <>{"( "}{rowInfo.row.original.col25}{" )"}</> : ""}</p>
                                : <p>{rowInfo.row.original.col4} {currentUser.see_stock === 1 && currentUser.supplier_stock !== null && allowedSups.includes(rowInfo.row.original.col27) ? <>{"( "}{rowInfo.row.original.col25}{" )"}</> : ""}</p>}

                        </>
                    );
                },
            },
            {
                Header: 'Price Excl. VAT',
                accessor: 'col5',
                Cell: (rowInfo) => {
                    return (
                        <>
                            <p>{rowInfo.row.original.col5}

                                {rowInfo.row.original.col10 == "SD" ?
                                    <>
                                        <span className="text-green-500 ml-2" data-tip="ACT 36 Settlement Discount if Applicable"><FontAwesomeIcon icon={faExclamationCircle} /></span> <ReactTooltip />

                                    </>
                                    : ""}
                            </p>



                        </>
                    );
                },
            },
            {
                Header: 'QTY',
                accessor: 'col6',
                Cell: rowInfo => {
                    return (
                        // <Select 
                        //   options={[
                        //     { value: "01", label: "01" },
                        //     { value: "02", label: "02" },
                        //     { value: "03", label: "03" }
                        //   ]}
                        //   defaultValue={{ label: rowInfo.row.original.col6, value: rowInfo.row.original.col6 }}
                        //   isSearchable={false}
                        //   onChange={(values) => setTotals(values.value, rowInfo.row.original.col0)}
                        // />


                        <div>
                            {/* {rowInfo.row.original.col4 === "Out of Stock" ?
                                ""
                                : */}
                            <input type="number" min={rowInfo.row.original.col11 == "yes" ? "1" : "0"} defaultValue={Math.floor(parseFloat(rowInfo.row.original.col6))} className="shadow-sm text-sm border border_radius_5 w-20" onChange={(values) => { let mintot = rowInfo.row.original.col11 == "yes" ? 1 : 0; parseFloat(values.target.value) < mintot ? setTotals(mintot, rowInfo.row.original.col2) : setTotals(values.target.value, rowInfo.row.original.col2); if (values.target.value == 0) { values.target.value = mintot } else { values.target.value = Math.abs(values.target.value) } }} />
                            {/* } */}
                        </div>
                    );
                },
            },
            {
                Header: 'On Back Order',
                accessor: 'col26',
                Cell: (rowInfo) => {
                    return (
                        <>
                            {parseFloat(rowInfo.row.original.col26) !== 0 ?
                                <p className="text-red-500">YES ({parseFloat(rowInfo.row.original.col26)})</p>
                                : ""}
                        </>
                    );
                },
            },
            {
                Header: "",
                accessor: "col8",
                Cell: (rowInfo) => {
                    return (
                        <div>
                            {rowInfo.row.original.col4 === "Out of Stock" ?
                                <>
                                    {parseFloat(rowInfo.row?.original?.col9?.length) > 0 ?
                                        <>
                                            <button
                                                className="px-2 py-2 border border-transparent text-base font-medium border_radius_4 shadow-sm text-white bg-lk_grey_one hover:bg-lk_dark_grey_button_hover uppercase mx-auto"
                                                onClick={() => dispatch(openModal({ modalType: "Alternative", modalProps: { stockCode: rowInfo.row.original.col2 } }))}
                                            >
                                                See Alternative
                                            </button>
                                        </>
                                        : ""}
                                    {/* No Alternative Available */}

                                </>
                                :
                                ""
                            }
                        </div>
                    );
                },
            },
            {
                Header: '',
                accessor: 'col7',
                Cell: rowInfo => {
                    const promoBlocked = isPromoBlockedItem(rowInfo.row.original);
                    return (
                        <div className="flex">
                            {rowInfo.row.original.col7 === true ? (
                                <FontAwesomeIcon
                                    icon={solidHeart}
                                    className="absolute top-3 right-3 text-xl text-gray-500 cursor-pointer"
                                    onClick={() =>
                                        removeFavourite(
                                            rowInfo.row.original.col2
                                        )
                                    }
                                />
                            ) : (
                                <FontAwesomeIcon
                                    icon={faHeart}
                                    className="absolute top-3 right-3 text-xl text-gray-500 cursor-pointer"
                                    onClick={() =>
                                        addFavourite(rowInfo.row.original.col2)
                                    }
                                />
                            )}



                            {/* {JSON.parse(window.sessionStorage.getItem("itemsIdsInBasket")) !== null && JSON.parse(
                                window.sessionStorage.getItem(
                                    "itemsIdsInBasket"
                                )
                            ).includes(
                                (rowInfo.row.original.col2).trim()
                            ) ? (
                                <>
                                    <button
                                        className="px-4 py-2 mr-5 border border-transparent text-base font-medium border_radius_4 shadow-sm text-white bg-lk_grey_one hover:bg-lk_dark_grey_button_hover uppercase mx-auto"
                                        onClick={() =>
                                            history.push("/view-cart")
                                        }
                                    >
                                        View Cart
                                    </button>
                                </>
                            ) : (
                                <>
                                {rowInfo.row.original.col4 === "Out of Stock" ? 
                                    <>
                                        
                                    </> 
                                : 
                                    <> */}
                            {promoBlocked ? (
                                <button
                                    type="button"
                                    disabled
                                    className="px-4 py-2 mr-5 border border-transparent text-base font-medium border_radius_4 shadow-sm text-white bg-lk_grey_one uppercase mx-auto flex opacity-50 cursor-not-allowed"
                                    title="Promo items cannot be added from order history"
                                >
                                    Promo Item
                                </button>
                            ) : (
                                <button
                                    className="px-4 py-2 mr-5 border border-transparent text-base font-medium border_radius_4 shadow-sm text-white bg-lk_grey_one hover:bg-lk_dark_grey_button_hover uppercase mx-auto flex"
                                    onClick={() =>
                                        addItemToCart(
                                            rowInfo.row.original.col2,
                                            rowInfo.row.original.col6
                                        )
                                    }
                                >
                                    <span className="pr-2 mt-1">+</span> <FontAwesomeIcon icon={faShoppingCart} className="mt-2" />
                                </button>
                            )}

                            {rowInfo.row.original.col11 == "yes" ? (
                                <span className="mt-6 bg-red-500 h-7 px-2 py-1 rounded-full text-white mr-1 min-w-min_red_btn flex justify-center" data-tip={Math.floor(rowInfo.row.original.col6) + " of this item is in your cart"}>
                                    {Math.floor(rowInfo.row.original.col6)}
                                    <ReactTooltip />
                                </span>
                            ) : (
                                <div className="mt-6 h-6 px-2 py-1 rounded-full text-white"></div>
                            )}
                            {/* </>
                                }
                                    
                                </>
                            )} */}


                        </div>
                    );
                },
            },

        ],
        []
    )

    async function repeatThisOrder(orderItems) {
        if (isRepeating) return;
        try {
            if (!Array.isArray(orderItems) || orderItems.length === 0) {
                toast.error("No items to repeat", { position: "bottom-right", autoClose: 5000, closeOnClick: true });
                return;
            }

            const filteredItems = orderItems.filter((item) => !isPromoBlockedItem(item));
            if (filteredItems.length === 0) {
                toast.error("Promo items cannot be repeated", { position: "bottom-right", autoClose: 5000, closeOnClick: true });
                return;
            }
            if (filteredItems.length !== orderItems.length) {
                toast.info("Promo items were excluded from repeat order", { position: "bottom-right", autoClose: 5000, closeOnClick: true });
            }

            setIsRepeating(true);
            for (const item of filteredItems) {
                const itemId = `${item.col0}`.trim();
                const qty = parseFloat(item.col6) || 0;

                if (!itemId || qty <= 0) continue;

                // Maintain legacy session storage state for cart UI expectations.
                const prevItemClickedRaw = JSON.parse(window.sessionStorage.getItem("itemsClicked"));
                const prevItemClicked = Array.isArray(prevItemClickedRaw)
                    ? prevItemClickedRaw
                    : prevItemClickedRaw
                        ? [prevItemClickedRaw]
                        : [];
                prevItemClicked.push(itemId);
                window.sessionStorage.setItem("itemsClicked", JSON.stringify(prevItemClicked));

                const prevItemIdsRaw = JSON.parse(window.sessionStorage.getItem("itemsIdsInBasket"));
                const prevItemIds = Array.isArray(prevItemIdsRaw)
                    ? prevItemIdsRaw
                    : prevItemIdsRaw
                        ? [prevItemIdsRaw]
                        : [];

                if (!prevItemIds.includes(itemId)) {
                    prevItemIds.push(itemId);
                    const CurrentCartAmount = window.sessionStorage.getItem("itemsInBasket");
                    const NewAmount = CurrentCartAmount === null ? 1 : parseFloat(CurrentCartAmount) + 1;
                    window.sessionStorage.setItem("itemsInBasket", NewAmount);
                    setCartTotal(NewAmount);
                }

                window.sessionStorage.setItem("itemsIdsInBasket", JSON.stringify(prevItemIds));

                const prevItemTotalsRaw = JSON.parse(window.sessionStorage.getItem("totalItemsInBasket"));
                const prevItemTotals = Array.isArray(prevItemTotalsRaw)
                    ? prevItemTotalsRaw
                    : prevItemTotalsRaw
                        ? [prevItemTotalsRaw]
                        : [];
                prevItemTotals.push([item.col6, item.col0]);
                window.sessionStorage.setItem("totalItemsInBasket", JSON.stringify(prevItemTotals));

                await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_API_URL}add-items-to-cart`,
                    headers: { Authorization: `Bearer ${currentUser.token}` },
                    data: {
                        StockCode: itemId,
                        id: currentUser.id,
                        qty: qty,
                        auto: 0,
                        customer_code: currentUser.customer_code,
                    },
                    timeout: 20000,
                });
            }

            dispatch(getCartTotal(currentUser));
            toast.success("Items added to cart", { position: "bottom-right", autoClose: 5000, closeOnClick: true });
            window.localStorage.setItem("is_repeat_order", "true");
        } catch (error) {
            console.error("repeatThisOrder failed", error);
            toast.error("Failed to repeat order", { position: "bottom-right", autoClose: 5000, closeOnClick: true });
        } finally {
            setIsRepeating(false);
        }

    }

    async function createTemplate(orderItems) {
        dispatch(openModal({ modalType: "TemplateName", modalProps: { orderItems: orderItems } }))
    }

    function getBundlePaymentRetry(bundle) {
        return bundle.paymentRetry || bundle.orderTrack?.payment_retry || bundle.paymentDetails?.payment_retry || bundle.latestPayment?.payment_retry;
    }

    async function retryOrderPayment(orderId, paymentRetry) {
        if (!canRetryPaym8(paymentRetry) || retryingPaymentOrderId) {
            return;
        }

        setRetryingPaymentOrderId(orderId);
        setPaymentRetryMessages((messages) => ({
            ...messages,
            [orderId]: null,
        }));

        try {
            const response = await retryPaym8Order({
                paymentRetry: paymentRetry,
                orderId: orderId,
                token: currentUser.token,
            });

            if (response.data?.redirect_url) {
                window.location.href = response.data.redirect_url;
                return;
            }

            setPaymentRetryMessages((messages) => ({
                ...messages,
                [orderId]: {
                    type: "warning",
                    text: "Payment retry did not return a PayM8 redirect.",
                },
            }));
        } catch (error) {
            setPaymentRetryMessages((messages) => ({
                ...messages,
                [orderId]: {
                    type: getPaym8RetryMessageType(error),
                    text: getPaym8RetryErrorMessage(error),
                },
            }));
        } finally {
            setRetryingPaymentOrderId("");
        }
    }

    function getRetryMessageClass(type) {
        if (type === "success") {
            return "text-green-700";
        }

        if (type === "warning") {
            return "text-yellow-700";
        }

        return "text-red-700";
    }



    return (
        <div className="bg-gray-50">
            <AdminSearchForm
                heading="Orders"
                color="text-gray-500"
                header_color="bg-gradient-to-b from-gray-300"
                crumb_color="text-black"
                breadcrumbs={[
                    { name: "Home", href: "/", count: 1 },
                    { name: "Orders", href: "/orders", count: 2 },
                    { name: "Order", href: "/order/" + orderId, count: 3 },
                ]}
            />

            <ToastContainer />
            {isRepeating && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                    <div className="rounded-lg bg-white px-6 py-5 text-center shadow-lg">
                        <div className="mx-auto mb-3 h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-lk_red" />
                        <p className="text-lg font-semibold">Adding items to cart...</p>
                        <p className="text-sm text-gray-500">Please wait, this can take a few seconds.</p>
                    </div>
                </div>
            )}

            {/* <AdminNav cartTotal={cartTotal}/> */}
            <br /><br />

            {orderBundles.length === 0 ? (
                <div className="container mx-auto relative">
                    <p className="text-4xl">Order {orderId}</p>
                </div>
            ) : (
                orderBundles.map((bundle, index) => (
                    <div key={`${bundle.orderId || "order"}-${index}`} className={`container mx-auto ${index === 0 ? "mt-6" : "mt-14"}`}>
                        <div className="relative">
                            <p className="text-4xl">Order {bundle.orderId}</p>

                            <p>Order No: {bundle.orderTrack && bundle.orderTrack.order_po_no ? bundle.orderTrack.order_po_no : "Not Set"}</p>

                            <p>Payment: {bundle.paymentDetails && bundle.paymentDetails.status ? (bundle.paymentDetails.status === 1 ? "Cash - Success" : "Cash - Error") : "Account"}</p>

                            {canRetryPaym8(getBundlePaymentRetry(bundle)) && (
                                <div className="mt-3">
                                    <button
                                        type="button"
                                        className="px-5 py-2 border border-transparent text-sm font-medium border_radius_4 shadow-sm text-white bg-lk_red hover:bg-lk_red_hover uppercase disabled:opacity-50"
                                        disabled={retryingPaymentOrderId === bundle.orderId}
                                        onClick={() => retryOrderPayment(bundle.orderId, getBundlePaymentRetry(bundle))}
                                    >
                                        {retryingPaymentOrderId === bundle.orderId ? "Retrying..." : "Retry payment"}
                                    </button>
                                </div>
                            )}

                            {paymentRetryMessages[bundle.orderId]?.text && (
                                <p className={`mt-2 text-sm font-medium ${getRetryMessageClass(paymentRetryMessages[bundle.orderId].type)}`}>
                                    {paymentRetryMessages[bundle.orderId].text}
                                </p>
                            )}

                            {bundle.comments?.map((comment) => (
                                <p key={comment.id}>Comment: {comment.Text}</p>
                            ))}

                            {/* <p className="mt-5 w-1/3">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p> */}
                            <div className="flex justify-end mt-4">
                                <button
                                    className={`inline-flex items-right px-12 py-2 ml-3 border border-transparent text-base font-medium border_radius_4 shadow-sm text-white bg-lk_red hover:bg-lk_red_hover uppercase ${isRepeating ? "opacity-60 cursor-not-allowed" : ""}`}
                                    onClick={() => repeatThisOrder(bundle.items)}
                                    disabled={isRepeating}
                                >
                                    repeat order
                                </button>
                                <button className="inline-flex items-right px-12 py-2 ml-3 border border-transparent text-base font-medium border_radius_4 shadow-sm text-white bg-lk_red hover:bg-lk_red_hover uppercase" onClick={() => createTemplate(bundle.items)}>
                                    Make template
                                </button>
                            </div>
                        </div>

                        <div className="mt-10">
                            <OrderTable items={bundle.items} columns={columns} />
                        </div>
                    </div>
                ))
            )}

        </div>
    )
}
